import { supabase } from './supabase';

export const MAX_DAILY_SEARCHES = 7;

const GUEST_LIMIT_KEY = 'bl_daily_limit';

// ── Guest helpers (localStorage) ─────────────────────────────────────────────

function guestRead() {
  try {
    const stored = JSON.parse(localStorage.getItem(GUEST_LIMIT_KEY) || '{}');
    const today  = new Date().toDateString();
    if (stored.date !== today) return { count: 0, date: today };
    return { count: stored.count || 0, date: today };
  } catch {
    return { count: 0, date: new Date().toDateString() };
  }
}

export function getGuestSearchCount() {
  return guestRead().count;
}

export function incrementGuestCount() {
  const current = guestRead();
  const updated = { count: current.count + 1, date: current.date };
  try { localStorage.setItem(GUEST_LIMIT_KEY, JSON.stringify(updated)); } catch {}
  return updated.count;
}

// ── Logged-in user (Supabase) ─────────────────────────────────────────────────

export async function getUserSearchCount(userId) {
  const todayStart = new Date();
  todayStart.setHours(0, 0, 0, 0);

  // Use a regular SELECT (not HEAD/count:exact) — more reliable on Supabase free tier
  const { data, error } = await supabase
    .from('learning_sessions')
    .select('id')
    .eq('user_id', userId)
    .gte('created_at', todayStart.toISOString());

  if (error) return 0;
  return data?.length || 0;
}

// ── Check limit ───────────────────────────────────────────────────────────────

export function isLimitReached(count, userRole, tier) {
  // Admins and super admins have unlimited searches
  if (userRole === 'admin' || userRole === 'super_admin') return false;
  // Paid tiers (individual, team) have unlimited searches
  if (tier === 'individual' || tier === 'team') return false;
  return count >= MAX_DAILY_SEARCHES;
}
